import { render } from "./postPreview.vue?vue&type=template&id=06f3d48a&scoped=true"
import script from "./postPreview.vue?vue&type=script&lang=js"
export * from "./postPreview.vue?vue&type=script&lang=js"

import "./postPreview.vue?vue&type=style&index=0&id=06f3d48a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f3d48a"]])

export default __exports__